import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/Store';
import Spinner from './views/spinner/Spinner';
import './utils/i18n';
import { initSentry, setSentryUser, logAppBootstrap } from './utils/sentry';
import { createAppRouter } from './utils/sentryRouting';

initSentry();
logAppBootstrap();

const idCcnUser = localStorage.getItem('idCcnUser');
if (idCcnUser) {
  setSentryUser({
    id: String(idCcnUser),
    email: localStorage.getItem('mail') || undefined,
    username: localStorage.getItem('nameSurname') || undefined,
  });
}

const router = createAppRouter({
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true,
  },
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <Suspense fallback={<Spinner />}>
      <RouterProvider router={router} />
    </Suspense>
  </Provider>,
);
